import React, { useContext, useEffect, useState, useMemo } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate, useParams } from "react-router-dom";
import {
    Button, FloatButton, Progress, Table, TableProps, Tag, Typography,
    Card, Space, Tooltip, Modal, Alert, message, Input, Dropdown,
    Row, Col, Statistic, Badge, Select, Spin, DatePicker
} from "antd";
import dayjs from 'dayjs';
import { PostActivitat } from "../../../../dao/jutge/PostActivitat";

import { AuthContext } from "../../../../config/AuthContext";
import { ColumnsType } from "antd/es/table";
import { BiArrowFromLeft, BiPlus, BiRefresh } from "react-icons/bi";
import AppSider from "../../components/AppSider";
import { Content } from "antd/es/layout/layout";
import { GetUsuariIdJutgeActivitats } from "../../../../dao/GetUsuariIdJutgeActivitats";
import { GetSceneNames } from "../../../../dao/jutge/GetJavamonConfig";
import JutgeColors, { aulaColor as aulaColorFn } from "../../../../styles/JutgeColors";
import { FaCopy, FaEye, FaUsers } from "react-icons/fa";
import { VscSettingsGear } from "react-icons/vsc";
import { IoOptions } from "react-icons/io5";
import { MdCatchingPokemon, MdAccessTime, MdStar } from "react-icons/md";
import { FaListCheck } from "react-icons/fa6";
import ConfiguracioModal from "./ConfiguracioModal";
import ExercicisModal from "./ExercicisModal";
import AvaluacioColors from "../../../../styles/AvaluacioColors";
import CopyModal from "./CopyModal";
import ActivitatAlumnesModal from "./ActivitatAlumnesModal";
import useWebSocketSubscription, { UseWebSocketSubscription } from "../../../UseWebSocketSubscription";
import { PostUseTimeJavamon } from "../../../../dao/jutge/PostUseTimeJavamon";
import SelectJavamonTimeModal from './SelectJavamonTimeModal';
import SelectJavamonNotaModal from './SelectJavamonNotaModal';
import { PostUseNotaJavamon } from "../../../../dao/jutge/PostUseNotaJavamon";
import { PostUseItem } from "../../../../dao/jutge/PostUseItem";
import { GetPracticaIdImagen } from "../../../../dao/GetPracticaIdImagen";
import { PutPracticaOrdre } from "../../../../dao/jutge/PutPracticaOrdre";
import { ReorderActivitats } from "../../../../dao/jutge/ReorderActivitats";
import { DndContext, DragEndEvent, DragOverlay, PointerSensor, useSensor, useSensors, closestCenter } from '@dnd-kit/core';
import { SortableContext, arrayMove, useSortable, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import {
    MenuOutlined, ArrowUpOutlined, ArrowDownOutlined, MoreOutlined, AreaChartOutlined,
    CodeOutlined, CheckCircleOutlined, ReloadOutlined, SearchOutlined, FireOutlined, CaretDownOutlined,
    EditOutlined, FileExcelOutlined, ApartmentOutlined
} from '@ant-design/icons';
import { getJavamonImage } from '../../../../dao/jutge/GetJavamonConfig';
import ActivitatsIdEstadistiques from '../../activitatsId/content/ActivitatsIdEstadistiques';
import ImportarActivitatCompletaExcelModal from './ImportarActivitatCompletaExcelModal';
import AssignarRAsMassiuModal from './AssignarRAsMassiuModal';

const { Title, Text } = Typography;

interface ActivitatImagenProps {
    id: number;
}

const ActivitatImagen: React.FC<ActivitatImagenProps> = ({ id }) => {
    const [base64, setBase64] = useState<string | null>(null);

    useEffect(() => {
        let mounted = true;

        GetPracticaIdImagen(id + "")
            .then((res: any) => {
                if (mounted && res?.imagen) {
                    const cleaned = res.imagen.split(':').pop();
                    setBase64(cleaned);
                }
            })
            .catch(() => {
                if (mounted) setBase64(null);
            });

        return () => { mounted = false; };
    }, [id]);

    if (!base64) return <div style={{ width: 50, height: 50, background: '#eee', borderRadius: 12 }} />;

    return (
        <img
            src={`data:image/png;base64,${base64}`}
            alt="avatar"
            style={{
                width: 50,
                height: 50,
                objectFit: 'cover',
                borderRadius: 12,
                boxShadow: '0 1px 4px rgba(0,0,0,0.1)'
            }}
        />
    );
};

interface RowContextProps {
    setActivatorNodeRef?: (element: HTMLElement | null) => void;
    listeners?: any;
    attributes?: any;
}

const RowContext = React.createContext<RowContextProps>({});

interface DragRowProps extends React.HTMLAttributes<HTMLTableRowElement> {
    'data-row-key': string;
}

const TableDragRow = (props: DragRowProps) => {
    const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition, isDragging } = useSortable({
        id: props['data-row-key'],
    });

    const style: React.CSSProperties = {
        ...props.style,
        transform: CSS.Translate.toString(transform),
        transition,
        ...(isDragging ? { position: 'relative', zIndex: 9999 } : {}),
    };

    const contextValue = useMemo(
        () => ({ setActivatorNodeRef, listeners, attributes }),
        [setActivatorNodeRef, listeners, attributes]
    );

    return (
        <RowContext.Provider value={contextValue}>
            <tr {...props} ref={setNodeRef} style={style} />
        </RowContext.Provider>
    );
};

interface ActivitatsProps {
    isGameModal?: boolean;
}

const Activitats: React.FC<ActivitatsProps> = ({ isGameModal = false }) => {
    const { isLoggedIn, user, setBreadCrumb, setUser, alumne } = useContext(AuthContext);
    const navigate = useNavigate();


    // console.log("Activitats - User Object:", user);
    const userId = user?.id || (user as any)?.idUsuari;
    // console.log("Activitats - Derived userId:", userId);

    const [dades, setDades] = useState<any[]>([]);
    // Nombre visible configurado para la escena inicial "Pueblo 0" (modo juego).
    const [pueblo0DisplayName, setPueblo0DisplayName] = useState<string>("Pueblo 0");
    const [loading, setLoading] = useState(false);
    const [modal, setModal] = useState(false);
    const [modalE, setModalE] = useState(false);
    const [modalCopy, setModalCopy] = useState(false);
    const [modalAlumnes, setModalAlumnes] = useState(false);
    const [selected, setSelected] = useState<any>();
    const [pantalla, setPantalla] = useState(0);
    const [showJavamonModal, setShowJavamonModal] = useState(false);
    const [showJavamonNotaModal, setShowJavamonNotaModal] = useState(false);
    const [activityForJavamon, setActivityForJavamon] = useState<string>("");
    const [incenseTimeLeft, setIncenseTimeLeft] = useState<string | null>(null);
    const [modalEstadistiques, setModalEstadistiques] = useState(false);
    const [selectedEstadistiquesId, setSelectedEstadistiquesId] = useState<string | null>(null);
    const [modalImportExcel, setModalImportExcel] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [selectedAula, setSelectedAula] = useState<string | number>('all');
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [modalAssignarRAs, setModalAssignarRAs] = useState(false);

    // Llista d'aules úniques derivades de les dades
    const availableAulas = useMemo(() => {
        if (!Array.isArray(dades)) return [];
        const map = new Map<number | string, string>();
        dades.forEach((item: any) => {
            if (item.id_aula !== undefined && item.id_aula !== null) {
                if (!map.has(item.id_aula)) {
                    map.set(item.id_aula, item.aula || `Aula ${item.id_aula}`);
                }
            }
        });
        return Array.from(map.entries()).map(([id, nom]) => ({ id, nom }));
    }, [dades]);

    // Si només hi ha 1 aula, fixar-la automàticament; si n'hi ha més d'una, 'all' per defecte
    useEffect(() => {
        if (availableAulas.length === 1) {
            setSelectedAula(availableAulas[0].id);
        } else if (availableAulas.length > 1 && selectedAula !== 'all') {
            const exists = availableAulas.some(a => String(a.id) === String(selectedAula));
            if (!exists) setSelectedAula('all');
        }
    }, [availableAulas]);

    // Dades filtrades primer per aula i després per text de cerca
    const filteredDades = useMemo(() => {
        if (!Array.isArray(dades)) return [];
        return dades.filter((item: any) => {
            // En el modal del juego (iframe de Unity) no se muestra la columna Estat (que
            // en la web filtra por defecto las ocultas). Aquí excluimos manualmente las
            // actividades OCULTAS (estatr === 5) para que no aparezcan en el selector.
            if (isGameModal && Number(item.estatr) === 5) {
                return false;
            }
            // Filtre d'aula: si selectedAula no és 'all', ha de coincidir
            if (selectedAula !== 'all' && String(item.id_aula) !== String(selectedAula)) {
                return false;
            }
            // Filtre de text de cerca
            if (searchText.trim()) {
                const q = searchText.toLowerCase();
                const matches = (item.nom && item.nom.toLowerCase().includes(q)) ||
                    (item.aula && item.aula.toLowerCase().includes(q)) ||
                    (item.escena && item.escena.toLowerCase().includes(q)) ||
                    (item.tags && item.tags.toLowerCase().includes(q)) ||
                    String(item.id).includes(q);
                if (!matches) return false;
            }
            return true;
        });
    }, [dades, selectedAula, searchText, isGameModal]);

    const stats = useMemo(() => {
        if (!Array.isArray(filteredDades) || filteredDades.length === 0) {
            return { total: 0, active: 0, completed: 0, avgProgress: 0 };
        }
        let active = 0;
        let completed = 0;
        let sumProgress = 0;

        filteredDades.forEach((act: any) => {
            if (act.estat === 3) active++;
            const prog = Number(act.progres) || 0;
            if (prog >= 100) completed++;
            sumProgress += prog;
        });

        return {
            total: filteredDades.length,
            active,
            completed,
            avgProgress: Math.round(sumProgress / filteredDades.length)
        };
    }, [filteredDades]);

    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: {
                distance: 1, // Require dragging 1px to start
            },
        })
    );


    useEffect(() => {
        const checkIncense = () => {
            const expiry = localStorage.getItem('incense_expiry');
            if (expiry) {
                const diff = parseInt(expiry) - Date.now();
                if (diff > 0) {
                    const mins = Math.floor(diff / 60000);
                    const secs = Math.floor((diff % 60000) / 1000);
                    setIncenseTimeLeft(`${mins}m ${secs}s`);
                } else {
                    setIncenseTimeLeft(null);
                    localStorage.removeItem('incense_expiry');
                }
            } else {
                setIncenseTimeLeft(null);
            }
        };

        checkIncense(); // Initial check
        const interval = setInterval(checkIncense, 1000);

        // Listen for storage events (if user activates in another tab/component)
        const handleStorage = () => checkIncense();
        window.addEventListener('storage', handleStorage);

        return () => {
            clearInterval(interval);
            window.removeEventListener('storage', handleStorage);
        };
    }, []);

    // En el modal del juego, resolvemos el nombre visible configurado para "Pueblo 0"
    // (la escena inicial) para mostrarlo en el botón fijo. Si no hay nombre configurado
    // o la consulta falla, se mantiene "Pueblo 0".
    useEffect(() => {
        if (!isGameModal) return;
        (async () => {
            try {
                const names = await GetSceneNames();
                if (Array.isArray(names)) {
                    const found = names.find((n: any) => n.scene_name === "Pueblo 0");
                    if (found && found.display_name) {
                        setPueblo0DisplayName(String(found.display_name));
                    }
                }
            } catch (e) {
                // Silencioso: se mantiene el valor por defecto "Pueblo 0".
            }
        })();
    }, [isGameModal]);

    useEffect(() => {
        if (isLoggedIn) {
            // Si el usuario es alumno y el aula está en modo examen, se bloquea el acceso por URL y se redirige hacia atrás
            if (user.tipus === "2") {
                const userAulas = alumne?.aules || [];
                const hasExamMode = (userAulas || []).some((a: any) =>
                    Boolean(a.isExamen === 1 || a.isExamen === true || a.is_examen === 1 || a.is_examen === true)
                );
                if (hasExamMode) {
                    navigate(-1);
                    return;
                }
            }

            setBreadCrumb([
                { nom: 'Home', nav: '/home' },
                { nom: 'jutge', nav: '/jutge' },
                { nom: 'activitats', nav: '/jutge/activitats' }
            ], true);
            checkDades();
        }
    }, [isLoggedIn]); // Added isLoggedIn to dep array

    UseWebSocketSubscription(["/topic/home", "/topic/activitats"], (topic, msg) => {
        if (msg === true || msg?.accion === "REFRESH" || topic === "/topic/home") {
            checkDades(false);
        }
    });
    async function checkDades(refresh: boolean = true) {
        if (refresh) setLoading(true);
        const data = await GetUsuariIdJutgeActivitats(userId);
        setDades(data || []);
        setLoading(false);
    }

    const [updatingStatusId, setUpdatingStatusId] = useState<number | null>(null);

    async function handleQuickChangeEstat(record: any, newEstat: number) {
        if (updatingStatusId) return;
        setUpdatingStatusId(record.id);
        try {
            const payload = {
                id: record.id,
                nom: record.nom,
                estat: newEstat,
                id_aula: record.id_aula,
                is_examen: record.is_examen ? 1 : 0,
                is_concurs: record.is_concurs ? 1 : 0,
                is_ide: record.is_ide ? 1 : 0,
                context: record.context || "",
                id_usuari: userId,
                tipus: record.tipus_aula ?? record.tipus ?? 0,
                id_season: record.id_season || 1,
                inici: record.inici ? dayjs(record.inici.toString().substring(0, 19).replace('T', ' ')).format('YYYY-MM-DD HH:mm:ss') : null,
                fin: record.final ? dayjs(record.final.toString().substring(0, 19).replace('T', ' ')).format('YYYY-MM-DD HH:mm:ss') : null,
                javamons: record.javamons ?? 10,
                minim: record.minim ?? 0,
                escena: record.escena || null,
                inst: "",
                ras: (record.ras || []).map((r: any) => ({
                    id: r.id,
                    percentatge: r.percentatge || 0,
                    instrument: r.instrument
                }))
            };

            await PostActivitat(payload);
            message.success("Estat de l'activitat actualitzat");
            await checkDades(false);
        } catch (err: any) {
            console.error("Error al canviar l'estat:", err);
            message.error("Error al canviar l'estat");
        } finally {
            setUpdatingStatusId(null);
        }
    }

    const [updatingDateId, setUpdatingDateId] = useState<number | null>(null);

    async function handleQuickChangeDate(record: any, field: 'inici' | 'final', newDate: dayjs.Dayjs | null) {
        if (updatingDateId) return;
        setUpdatingDateId(record.id);
        try {
            const formattedDate = newDate ? newDate.format('YYYY-MM-DD HH:mm:ss') : null;
            const payload = {
                id: record.id,
                nom: record.nom,
                estat: record.estatr ?? record.estat,
                id_aula: record.id_aula,
                is_examen: record.is_examen ? 1 : 0,
                is_concurs: record.is_concurs ? 1 : 0,
                is_ide: record.is_ide ? 1 : 0,
                context: record.context || "",
                id_usuari: userId,
                tipus: record.tipus_aula ?? record.tipus ?? 0,
                id_season: record.id_season || 1,
                inici: field === 'inici' ? formattedDate : (record.inici ? dayjs(record.inici.toString().substring(0, 19).replace('T', ' ')).format('YYYY-MM-DD HH:mm:ss') : null),
                fin: field === 'final' ? formattedDate : (record.final ? dayjs(record.final.toString().substring(0, 19).replace('T', ' ')).format('YYYY-MM-DD HH:mm:ss') : null),
                javamons: record.javamons ?? 10,
                minim: record.minim ?? 0,
                escena: record.escena || null,
                inst: "",
                ras: (record.ras || []).map((r: any) => ({
                    id: r.id,
                    percentatge: r.percentatge || 0,
                    instrument: r.instrument
                }))
            };

            await PostActivitat(payload);
            message.success(`Data de ${field === 'inici' ? 'inici' : 'finalització'} actualitzada`);
            await checkDades(false);
        } catch (err: any) {
            console.error("Error al actualitzar la data:", err);
            message.error("Error al actualitzar la data");
        } finally {
            setUpdatingDateId(null);
        }
    }

    function showSettings(ele: any) {
        setSelected(ele);
        setModal(true);
    }

    function showExercicis(ele: any) {
        setSelected(ele);
        setModalE(true);
    }

    function showDuplicar(ele: any) {
        setSelected(ele);
        setModalCopy(true);
    }

    function showAlumnes(ele: any) {
        setSelected(ele);
        setModalAlumnes(true);
    }

    function onCloseModal(reload: boolean) {
        setModal(false);
        setModalE(false);
        setModalCopy(false);
        if (reload) checkDades();
        else setLoading(false);
    }

    // Justo antes de definir columns:
    const aulaFilters = Array.from(
        new Map((Array.isArray(dades) ? dades : []).map(d => [d.id_aula, { text: d.aula, value: d.id_aula }])).values()
    );


    const today = new Date();

    const onDragEnd = async ({ active, over }: DragEndEvent) => {
        if (active.id !== over?.id) {
            setDades((previous) => {
                const activeIndex = previous.findIndex((i) => i.id === active.id);
                const overIndex = previous.findIndex((i) => i.id === over?.id);
                const newDades = arrayMove(previous, activeIndex, overIndex);

                // Reorder backend
                const ids = newDades.map(d => d.id + "");
                ReorderActivitats(ids).catch(err => {
                    message.error("Error al guardar el orden");
                    checkDades(false); // revert
                });

                return newDades;
            });
        }
    };

    const moveUp = (index: number) => {
        if (index > 0) {
            const newDades = [...dades];
            const temp = newDades[index];
            newDades[index] = newDades[index - 1];
            newDades[index - 1] = temp;

            setDades(newDades);
            const ids = newDades.map((d: any) => d.id + "");
            ReorderActivitats(ids);
        }
    };



    const moveDown = (index: number) => {
        if (index < dades.length - 1) {
            const newDades = [...dades];
            const temp = newDades[index];
            newDades[index] = newDades[index + 1];
            newDades[index + 1] = temp;
            setDades(newDades);

            const ids = newDades.map(d => d.id + "");
            ReorderActivitats(ids);
        }
    };

    const isAdmin = user.tipus === "0" || user.tipus === "1";

    const DragHandle: React.FC = () => {
        const { setActivatorNodeRef, listeners, attributes } = useContext(RowContext);
        return (
            <span
                ref={setActivatorNodeRef}
                {...listeners}
                {...attributes}
                style={{ cursor: 'grab', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', padding: '4px' }}
            >
                <MenuOutlined style={{ color: '#999', pointerEvents: 'none' }} />
            </span>
        );
    };

    const columns: ColumnsType<any> = [
        {
            key: 'ord',
            width: 50,
            align: 'center',
            hidden: !(user.tipus === "0" || user.tipus === "1"),
            render: (_t: any, ele: any) => ele.__isPueblo0 ? null : <DragHandle />,
        },
        {
            key: 'sort',
            title: 'Ordre',
            width: 80,
            align: 'center',
            hidden: !(user.tipus === "0" || user.tipus === "1"),
            render: (text, ele, index) => ele.__isPueblo0 ? null : (
                <Space direction="vertical" size={0}>
                    <Button
                        type="text"
                        size="small"
                        icon={<ArrowUpOutlined />}
                        disabled={index === 0}
                        onClick={() => moveUp(index)}
                    />
                    <Button
                        type="text"
                        size="small"
                        icon={<ArrowDownOutlined />}
                        disabled={index === dades.length - 1}
                        onClick={() => moveDown(index)}
                    />
                </Space>
            )
        },
        {
            key: 'imagen',
            dataIndex: 'imagen',
            width: 50,
            render: (_imgString: string, ele: any) => {
                if (ele.__isPueblo0) return null;
                return (
                    <div style={{ position: 'relative', width: 50, height: 50 }}>
                        <ActivitatImagen id={ele.id} />
                    </div>
                );
            }
        },
        /*{
            key: 'ordre',
            dataIndex: 'ordre',
            title: 'Pos',
            hidden: !(user.tipus === "0" || user.tipus === "1"),
            width:70,
            render: (val) => <Text type="secondary" style={{fontSize: 10}}>#{val}</Text>
        },*/
        {
            key: 'nom',
            dataIndex: 'nom',
            title: 'Nom',
            filters: aulaFilters,
            onFilter: (value, record) => (record as any).__isPueblo0 ? true : record.id_aula === value,
            render: (text, ele) => {
                if (ele.__isPueblo0) return null;
                const aulaColor = aulaColorFn(ele.id_aula);
                return (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <Text strong style={{ fontSize: '1rem' }}>{text}</Text>
                        <Text type="secondary" style={{ fontSize: '0.8rem' }}>
                            <Tag color={aulaColor} style={{ color: '#fff', border: 'none' }}>{ele.aula ?? ele.id_aula}</Tag> ID: {ele.id}
                        </Text>
                        {((ele.ras && ele.ras.length > 0) || ele.tags) && (
                            <div style={{ marginTop: 4, display: 'flex', flexWrap: 'wrap', gap: 4, alignItems: 'center' }}>
                                {ele.ras && ele.ras.map((ra: any) => {
                                    const raColors = [
                                        'magenta', 'red', 'volcano', 'orange', 'gold',
                                        'lime', 'green', 'cyan', 'blue', 'geekblue'
                                    ];
                                    const nomStr = (ra.nom !== undefined && ra.nom !== null) ? String(ra.nom) : '';
                                    const raNum = parseInt(nomStr.replace(/\D/g, ''), 10) || ra.id || 1;
                                    const color = raColors[Math.abs(raNum - 1) % raColors.length];
                                    const displayNom = nomStr.toUpperCase().startsWith('RA') ? nomStr : (nomStr ? `RA${nomStr}` : `RA${ra.id}`);

                                    return (
                                        <Tag key={`ra_${ra.id || Math.random()}`} color={color} style={{ fontSize: '0.75rem', margin: 0 }}>
                                            {displayNom} - {ra.instrument}
                                        </Tag>
                                    );
                                })}
                                {ele.tags && (
                                    (Array.isArray(ele.tags) ? ele.tags : String(ele.tags).split(/[\s,]+/))
                                        .map((t: string) => t.trim())
                                        .filter(Boolean)
                                        .map((tagStr: string, idx: number) => (
                                            <Tag
                                                key={`custom-tag-${idx}`}
                                                style={{
                                                    background: '#f0f5ff',
                                                    border: '1px solid #adc6ff',
                                                    color: '#1d39c4',
                                                    borderRadius: 12,
                                                    padding: '0 8px',
                                                    fontSize: '0.72rem',
                                                    fontWeight: 500,
                                                    margin: 0
                                                }}
                                            >
                                                #{tagStr}
                                            </Tag>
                                        ))
                                )}
                            </div>
                        )}
                    </div>
                );
            },
        },
        {
            key: 'dates',
            title: 'Dates',
            width: 175,
            align: 'center',
            render: (_, ele: any) => {
                if (ele.__isPueblo0) return null;
                const iniciVal = ele.inici ? dayjs(ele.inici.toString().substring(0, 19)) : null;
                const finalVal = ele.final ? dayjs(ele.final.toString().substring(0, 19)) : null;
                const formattedInici = iniciVal ? iniciVal.format('DD/MM/YYYY HH:mm') : null;
                const formattedFinal = finalVal ? finalVal.format('DD/MM/YYYY HH:mm') : null;

                if (!isAdmin) {
                    return (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 4, alignItems: 'center' }}>
                            {formattedInici ? <Tag color="green" style={{ margin: 0 }}>{formattedInici}</Tag> : <span style={{ color: '#bbb' }}>-</span>}
                            {formattedFinal ? (
                                <div style={{ display: 'inline-flex', gap: 4, alignItems: 'center' }}>
                                    <Tag color="red" style={{ margin: 0 }}>{formattedFinal}</Tag>
                                    {!!ele.extended && <Tag color="purple" style={{ margin: 0 }}>+24h ⏳</Tag>}
                                </div>
                            ) : <span style={{ color: '#bbb' }}>-</span>}
                        </div>
                    );
                }

                const isUpdating = updatingDateId === ele.id;
                return (
                    <div
                        style={{ display: 'flex', flexDirection: 'column', gap: 4, alignItems: 'center' }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <Tooltip title="Fes clic per modificar la data d'inici">
                            <div style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                backgroundColor: ele.inici ? '#f6ffed' : 'transparent',
                                borderRadius: 4,
                                padding: '0 6px',
                                height: 22
                            }}>
                                <DatePicker
                                    size="small"
                                    showTime={{ format: 'HH:mm' }}
                                    format="DD/MM/YYYY HH:mm"
                                    disabled={isUpdating}
                                    value={iniciVal}
                                    onChange={(d) => handleQuickChangeDate(ele, 'inici', d)}
                                    allowClear
                                    placeholder="Sense inici"
                                    renderExtraFooter={() => <span style={{ fontSize: 11, color: '#888' }}>Selecciona data d'inici</span>}
                                    style={{
                                        padding: 0,
                                        border: 'none',
                                        background: 'transparent',
                                        cursor: 'pointer',
                                        width: formattedInici ? 'auto' : 85,
                                        fontSize: '0.75rem',
                                        color: ele.inici ? '#389e0d' : undefined
                                    }}
                                />
                            </div>
                        </Tooltip>

                        <Tooltip title="Fes clic per modificar la data final">
                            <div style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: 4,
                                backgroundColor: ele.final ? '#fff1f0' : 'transparent',
                                borderRadius: 4,
                                padding: '0 6px',
                                height: 22
                            }}>
                                <DatePicker
                                    size="small"
                                    showTime={{ format: 'HH:mm' }}
                                    format="DD/MM/YYYY HH:mm"
                                    disabled={isUpdating}
                                    value={finalVal}
                                    onChange={(d) => handleQuickChangeDate(ele, 'final', d)}
                                    allowClear
                                    placeholder="Sense final"
                                    renderExtraFooter={() => <span style={{ fontSize: 11, color: '#888' }}>Selecciona data final</span>}
                                    style={{
                                        padding: 0,
                                        border: 'none',
                                        background: 'transparent',
                                        cursor: 'pointer',
                                        width: formattedFinal ? 'auto' : 85,
                                        fontSize: '0.75rem',
                                        color: ele.final ? '#cf1322' : undefined
                                    }}
                                />
                                {!!ele.extended && <Tag color="purple" style={{ margin: 0 }}>+24h</Tag>}
                            </div>
                        </Tooltip>
                    </div>
                );
            }
        },
        {
            key: 'estat',
            dataIndex: 'estat',
            title: 'Estat',
            align: 'center',
            filters: [
                { text: 'Actiu', value: 3 },
                { text: 'Tancat', value: 2 },
                { text: 'Revisió', value: 4 },
                { text: 'No visible', value: 1 },
                { text: 'Ocult', value: 5 },
            ],
            defaultFilteredValue: ['1', '2', '3', '4'],
            onFilter: (value, record) => {
                // La fila fija del Pueblo 0 nunca debe filtrarse.
                if ((record as any).__isPueblo0) return true;
                const real = Number(record.estatr);
                if (Number(value) === 5) return real === 5;
                if (real === 5) return false;
                return Number(record.estat) === Number(value);
            },
            render: (e, ele) => {
                if (ele.__isPueblo0) return null;
                const isOcult = Number(ele.estatr) === 5;
                const estat = isOcult ? 5 : e;
                const isCurrentUpdating = updatingStatusId === ele.id;

                const tagElement = (
                    <Tag
                        color={
                            estat === 3 ? JutgeColors.colors.color3 :
                                (estat === 2 ? JutgeColors.colors.color4 :
                                    (estat === 4 ? JutgeColors.colors.color5 :
                                        (estat === 5 ? "default" : "red")))
                        }
                        style={{
                            fontWeight: 'bold',
                            fontSize: '0.85rem',
                            margin: 0,
                            cursor: isAdmin ? 'pointer' : 'default',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 4,
                            userSelect: 'none',
                            transition: 'all 0.2s ease'
                        }}
                    >
                        {isCurrentUpdating ? (
                            <Spin size="small" style={{ marginRight: 4 }} />
                        ) : null}
                        {estat === 3 ? 'Actiu' : estat === 2 ? 'Tancat' : estat === 4 ? 'Revisió' : estat === 5 ? 'Ocult' : 'No visible'}
                        {isAdmin && !isCurrentUpdating && (
                            <CaretDownOutlined style={{ fontSize: '0.65rem', opacity: 0.7 }} />
                        )}
                    </Tag>
                );

                const statusMenu = isAdmin ? {
                    items: [
                        {
                            key: '3',
                            label: <Tag color={JutgeColors.colors.color3} style={{ fontWeight: 'bold' }}>Actiu</Tag>,
                            onClick: () => handleQuickChangeEstat(ele, 3)
                        },
                        {
                            key: '2',
                            label: <Tag color={JutgeColors.colors.color4} style={{ fontWeight: 'bold' }}>Tancat</Tag>,
                            onClick: () => handleQuickChangeEstat(ele, 2)
                        },
                        {
                            key: '1',
                            label: <Tag color="red" style={{ fontWeight: 'bold' }}>No visible</Tag>,
                            onClick: () => handleQuickChangeEstat(ele, 1)
                        },
                        {
                            key: '5',
                            label: <Tag color="default" style={{ fontWeight: 'bold' }}>Ocult</Tag>,
                            onClick: () => handleQuickChangeEstat(ele, 5)
                        }
                    ]
                } : undefined;

                return (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 4, alignItems: 'center' }}>
                        {isAdmin && statusMenu ? (
                            <Dropdown
                                menu={statusMenu}
                                trigger={['click']}
                                disabled={Boolean(updatingStatusId)}
                            >
                                <Tooltip title="Canviar estat">
                                    <span style={{ cursor: 'pointer' }}>
                                        {tagElement}
                                    </span>
                                </Tooltip>
                            </Dropdown>
                        ) : (
                            tagElement
                        )}
                        {(user.tipus === "0" || user.tipus === "1") && ele.escena && (
                            <Tag color="geekblue" style={{ margin: 0, fontSize: '0.75rem' }}>🎮 {ele.escena}</Tag>
                        )}
                        {ele.is_examen === 1 && (
                            <Tooltip title="Examen">
                                <Tag color="volcano" style={{ fontWeight: 'bold', fontSize: '0.85rem', margin: 0 }}>EX</Tag>
                            </Tooltip>
                        )}
                    </div>
                );
            }
        },
        {
            key: 'progres',
            dataIndex: 'progres',
            title: 'Progrés',
            render: (e, ele) => (
                !ele.__isPueblo0 && (!ele.is_examen || ele.estat === 4) && (
                    <Progress
                        percent={ele.progres}
                        strokeColor={{
                            '0%': JutgeColors.colors.color6,
                            '100%': JutgeColors.colors.color1,
                        }}
                        status={ele.progres === 100 ? "success" : "active"}
                        size="small"
                        format={(percent) => <span style={{ fontWeight: 'bold' }}>{percent}%</span>}
                    />
                )
            )
        },
        {
            key: 'actions',
            title: 'Accions',
            align: 'center',
            render: (e, ele) => {
                // Fila fija del Pueblo 0 (solo en el modal del juego): único botón en Accions.
                if (ele.__isPueblo0) {
                    return (
                        <Tooltip title={`Volver a ${pueblo0DisplayName}`}>
                            <Button
                                type="primary"
                                style={{
                                    backgroundColor: "#1890ff",
                                    borderColor: "#1890ff",
                                    fontWeight: "bold"
                                }}
                                onClick={() => {
                                    window.parent.postMessage({
                                        type: "TELEPORT_SCENE",
                                        scene: "Pueblo 0"
                                    }, "*");
                                }}
                            >
                                🏠 Ir a {pueblo0DisplayName}
                            </Button>
                        </Tooltip>
                    );
                }
                if (isGameModal) {
                    const hasScene = Boolean(ele.escena && ele.escena.trim());
                    const sceneLabel = (ele.scene_display_name && String(ele.scene_display_name).trim())
                        ? String(ele.scene_display_name).trim()
                        : (ele.escena || "Sin escena");

                    // Estado de plazo: aún no abierta (inici futuro) / fuera de plazo (final pasado) / en plazo.
                    const now = new Date();
                    const iniciDate = ele.inici ? new Date(ele.inici.toString().substring(0, 19).replace('T', ' ')) : null;
                    const finalDate = ele.final ? new Date(ele.final.toString().substring(0, 19).replace('T', ' ')) : null;
                    const notYetOpen = !!(iniciDate && iniciDate > now);
                    const pastDeadline = !!(finalDate && finalDate < now);

                    // Una actividad también está "cerrada" si su estado es Tancat (2), aunque no
                    // tenga fechas. En ese caso se puede VISITAR (botón amarillo), no "Ir a".
                    // Solo se considera abierta para "Ir a" cuando su estado es Actiu (3).
                    const isClosedByStatus = Number(ele.estat) === 2 || Number(ele.estatr) === 2;
                    const closed = pastDeadline || isClosedByStatus;

                    const travel = () => {
                        if (hasScene) {
                            window.parent.postMessage({
                                type: "TELEPORT_SCENE",
                                scene: ele.escena.trim(),
                                // Actividad elegida: así Unity carga los ejercicios de ESTA actividad
                                // y no los de otra que comparta la misma escena en el aula.
                                activityId: ele.id
                            }, "*");
                        }
                    };

                    // 1. Sin escena asignada: no se puede viajar.
                    if (!hasScene) {
                        return (
                            <Tooltip title="Esta actividad no tiene escena asignada">
                                <Button type="primary" disabled style={{ fontWeight: "bold" }}>
                                    🚀 Ir a {sceneLabel}
                                </Button>
                            </Tooltip>
                        );
                    }

                    // 2. Aún no abierta: bloqueada para alumnos, accesible para admin/profe (tipus 0 o 1).
                    if (notYetOpen) {
                        if (isAdmin) {
                            return (
                                <Tooltip title={`Disponible a partir del ${iniciDate ? iniciDate.toLocaleString() : ''} (Acceso profesor/admin)`}>
                                    <Button
                                        type="primary"
                                        style={{
                                            backgroundColor: "#722ed1",
                                            borderColor: "#722ed1",
                                            fontWeight: "bold"
                                        }}
                                        onClick={travel}
                                    >
                                        🚀 Ir a {sceneLabel}
                                    </Button>
                                </Tooltip>
                            );
                        }
                        return (
                            <Tooltip title={`Disponible a partir del ${iniciDate ? iniciDate.toLocaleString() : ''}`}>
                                <Button
                                    type="primary"
                                    disabled
                                    icon={<span>🔒</span>}
                                    style={{ fontWeight: "bold" }}
                                >
                                    Encara no disponible
                                </Button>
                            </Tooltip>
                        );
                    }

                    // 3. Cerrada (fuera de plazo o estado Tancat): se puede VISITAR para dar una vuelta.
                    if (closed) {
                        return (
                            <Tooltip title={`${sceneLabel} està tancada. Pots visitar-la per fer un volt, però ja no compta.`}>
                                <Button
                                    style={{
                                        backgroundColor: "#faad14",
                                        borderColor: "#faad14",
                                        color: "#fff",
                                        fontWeight: "bold"
                                    }}
                                    onClick={travel}
                                >
                                    🚶 Visitar {sceneLabel}
                                </Button>
                            </Tooltip>
                        );
                    }

                    // 4. En plazo: viaje normal.
                    return (
                        <Tooltip title={`Teletransportar a: ${sceneLabel}`}>
                            <Button
                                type="primary"
                                style={{
                                    backgroundColor: "#52c41a",
                                    borderColor: "#52c41a",
                                    fontWeight: "bold"
                                }}
                                onClick={travel}
                            >
                                🚀 Ir a {sceneLabel}
                            </Button>
                        </Tooltip>
                    );
                }

                return (
                    <Space>
                        {(user.tipus === "0" || user.tipus === "1" || (user.tipus === "2" && ele.estat !== 1 && (!ele.inici || new Date(ele.inici) <= new Date()))) &&
                            <Tooltip title={ele.estat !== 3 ? "Revisar" : "Accedir"}>
                                <Button
                                    style={{ backgroundColor: ele.estat !== 3 ? "orangered" : JutgeColors.colors.color2, border: 'none', color: '#fff' }}
                                    shape="circle"
                                    icon={<BiArrowFromLeft />}
                                    onClick={() => navigate(`/jutge/activitats/${ele.id}`)}
                                />
                            </Tooltip>
                        }


                        {(user.tipus === "2" && ele.estat === 4 && ele.is_examen) &&
                            <Tooltip title="Veure">
                                <Button shape="circle" icon={<FaEye />} />
                            </Tooltip>
                        }
                        {(user.tipus === "0" || user.tipus === "1") && (
                            <>
                                <Tooltip title="Estadístiques">
                                    <Button
                                        shape="circle"
                                        icon={<AreaChartOutlined />}
                                        onClick={() => {
                                            setSelectedEstadistiquesId(ele.id + "");
                                            setModalEstadistiques(true);
                                        }}
                                        style={{ backgroundColor: '#722ed1', border: 'none', color: '#fff' }}
                                    />
                                </Tooltip>
                                <Tooltip title="Alumnes">
                                    <Button
                                        shape="circle"
                                        icon={<FaUsers />}
                                        onClick={() => showAlumnes(ele)}
                                        style={{ backgroundColor: JutgeColors.colors.color1, border: 'none', color: '#fff' }}
                                    />
                                </Tooltip>
                                <Dropdown
                                    menu={{
                                        items: [
                                            {
                                                key: 'configurar',
                                                label: 'Configurar',
                                                icon: <VscSettingsGear style={{ color: JutgeColors.colors.color4 }} />,
                                                onClick: () => showSettings(ele)
                                            },
                                            {
                                                key: 'exercicis',
                                                label: 'Exercicis',
                                                icon: <FaListCheck style={{ color: JutgeColors.colors.color3 }} />,
                                                onClick: () => showExercicis(ele)
                                            },
                                            {
                                                key: 'duplicar',
                                                label: 'Duplicar',
                                                icon: <FaCopy style={{ color: JutgeColors.colors.color2 }} />,
                                                onClick: () => showDuplicar(ele)
                                            }
                                        ]
                                    }}
                                    trigger={['click']}
                                >
                                    <Button shape="circle" icon={<MoreOutlined />} />
                                </Dropdown>
                            </>
                        )}
                    </Space>
                );
            }
        }
    ];

    const tableProps: TableProps<any> = {
        loading,
        pagination: (isAdmin && !isGameModal) ? false : { pageSize: isGameModal ? 6 : 8 },
        showHeader: true,
        // En el modal del juego (iframe de Unity) la tabla es compacta y muestra solo
        // 3 columnas (imagen, nombre, botón de ir), así que caben sin scroll horizontal.
        ...(isGameModal ? { size: 'small' as const } : {}),
    };

    function setPnt(value: number) { setPantalla(value); }

    // En el modal del juego añadimos una fila fija al principio de la tabla con un único
    // botón "Ir al Pueblo 0" en la columna de Accions (resto de columnas vacías). Siempre
    // disponible, independientemente de las actividades.
    const PUEBLO0_ROW_KEY = '__pueblo0__';
    const dataSourceWithPueblo0 = isGameModal
        ? [{ id: PUEBLO0_ROW_KEY, __isPueblo0: true }, ...filteredDades]
        : filteredDades;

    // En el modal del juego (iframe de Unity) mostramos la MÍNIMA información para
    // poder viajar a un pueblo: imagen, nombre (con aula/id/RAs) y el botón de ir.
    // Fuera del juego se muestran todas las columnas normales.
    const displayColumns = isGameModal
        ? columns.filter((c: any) => ['imagen', 'nom', 'actions'].includes(c.key))
        : columns;

    const rowSelection = (isAdmin && !isGameModal) ? {
        selectedRowKeys,
        onChange: (keys: React.Key[]) => setSelectedRowKeys(keys),
        getCheckboxProps: (record: any) => ({
            disabled: !!record.__isPueblo0
        })
    } : undefined;

    const tableContent = (
        <>
            {selectedRowKeys.length > 0 && (
                <div style={{
                    marginBottom: 12,
                    padding: '10px 16px',
                    background: '#e6f7ff',
                    border: '1px solid #91d5ff',
                    borderRadius: 8,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    boxShadow: '0 2px 6px rgba(24,144,255,0.1)'
                }}>
                    <Space size="middle">
                        <span style={{ color: '#0050b3', fontWeight: 600 }}>
                            {selectedRowKeys.length} activitats seleccionades
                        </span>
                        <Button
                            type="primary"
                            icon={<ApartmentOutlined />}
                            onClick={() => setModalAssignarRAs(true)}
                            style={{ borderRadius: 6 }}
                        >
                            Assignar / Modificar RAs
                        </Button>
                    </Space>
                    <Button size="small" type="link" onClick={() => setSelectedRowKeys([])}>
                        Deseleccionar tot
                    </Button>
                </div>
            )}
            <Table
                {...tableProps}
                columns={displayColumns}
                dataSource={dataSourceWithPueblo0}
                rowSelection={rowSelection}
                components={isAdmin ? {
                    body: {
                        row: TableDragRow,
                    },
                } : undefined}
                size={isGameModal ? "small" : "middle"}
                bordered={false}
                rowKey="id"
                style={{
                    borderRadius: '12px',
                    overflow: 'hidden',
                    background: '#fff'
                }}
            />
        </>
    );

    return (
        <>
            {!isGameModal && <AppSider currentVal={2} setPantalla={setPnt} />}
            <Content
                style={{
                    background: '#f8f9fb',
                    padding: isGameModal ? '16px 20px' : '24px',
                    minHeight: isGameModal ? 'auto' : '100vh'
                }}
            >
                {/* Capçalera amb títol, cercador, mode desafiament i refrescar (Estil ActivitatsIdExercicis) */}
                <div style={{
                    marginBottom: 20,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: 16,
                    flexWrap: 'wrap'
                }}>
                    <div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            <Title level={3} style={{ margin: 0, display: 'flex', alignItems: 'center', gap: 8 }}>
                                <CodeOutlined style={{ color: isGameModal ? '#52c41a' : '#1890ff' }} />
                                {isGameModal ? 'Selecció d\'Activitats i Mòduls' : 'Mòduls Formatius'}
                            </Title>
                            {Array.isArray(dades) && (
                                <Badge
                                    count={filteredDades.length}
                                    style={{ backgroundColor: isGameModal ? '#52c41a' : '#1890ff', fontWeight: 600 }}
                                    overflowCount={999}
                                />
                            )}
                        </div>
                        <Typography.Text type="secondary" style={{ fontSize: 13 }}>
                            {isGameModal
                                ? 'Selecciona una activitat per viatjar directament a la seva escena al joc'
                                : 'Gestiona els mòduls formatius, activitats i el seguiment dels alumnes'}
                        </Typography.Text>
                    </div>

                    <Space wrap size="middle">
                        {/* Filtre per Aula */}
                        {availableAulas.length > 0 && (
                            <Select
                                value={selectedAula}
                                onChange={(val) => setSelectedAula(val)}
                                disabled={availableAulas.length === 1}
                                style={{ minWidth: 160, borderRadius: 8 }}
                                options={[
                                    ...(availableAulas.length > 1 ? [{ label: "🏫 Totes les aules", value: 'all' }] : []),
                                    ...availableAulas.map(a => ({
                                        label: `🏫 ${a.nom}`,
                                        value: a.id
                                    }))
                                ]}
                            />
                        )}

                        <Input
                            prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
                            placeholder="Cercar per nom, aula o ID..."
                            allowClear
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            style={{ width: 220, borderRadius: 8 }}
                        />



                        <Button
                            type="primary"
                            icon={<ReloadOutlined />}
                            onClick={() => checkDades(true)}
                            loading={loading}
                            style={{ borderRadius: 8 }}
                        >
                            Refrescar
                        </Button>
                    </Space>
                </div>

                {/* Targetes de resum KPI (ocultes al modal del joc per deixar la mínima info) */}
                {!isGameModal && (
                <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
                    <Col xs={24} sm={12} md={6}>
                        <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 10px rgba(0,0,0,0.04)' }} bodyStyle={{ padding: '16px 20px' }}>
                            <Statistic
                                title={<span style={{ color: '#8c8c8c', fontSize: 13 }}>Mòduls Totals</span>}
                                value={stats.total}
                                prefix={<CodeOutlined style={{ color: '#1890ff', marginRight: 6 }} />}
                                valueStyle={{ fontWeight: 700, fontSize: 26 }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} sm={12} md={6}>
                        <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 10px rgba(0,0,0,0.04)' }} bodyStyle={{ padding: '16px 20px' }}>
                            <Statistic
                                title={<span style={{ color: '#8c8c8c', fontSize: 13 }}>Mòduls Actius</span>}
                                value={stats.active}
                                suffix={<span style={{ fontSize: 14, color: '#8c8c8c' }}>/ {stats.total}</span>}
                                prefix={<CheckCircleOutlined style={{ color: '#52c41a', marginRight: 6 }} />}
                                valueStyle={{ color: '#52c41a', fontWeight: 700, fontSize: 26 }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} sm={12} md={6}>
                        <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 10px rgba(0,0,0,0.04)' }} bodyStyle={{ padding: '16px 20px' }}>
                            <Statistic
                                title={<span style={{ color: '#8c8c8c', fontSize: 13 }}>Mòduls Completats</span>}
                                value={stats.completed}
                                suffix={<span style={{ fontSize: 14, color: '#8c8c8c' }}>/ {stats.total}</span>}
                                prefix={<FireOutlined style={{ color: '#fa8c16', marginRight: 6 }} />}
                                valueStyle={{ color: '#fa8c16', fontWeight: 700, fontSize: 26 }}
                            />
                        </Card>
                    </Col>
                    <Col xs={24} sm={12} md={6}>
                        <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 10px rgba(0,0,0,0.04)' }} bodyStyle={{ padding: '16px 20px' }}>
                            <Statistic
                                title={<span style={{ color: '#8c8c8c', fontSize: 13 }}>Progrés Mitjà</span>}
                                value={stats.avgProgress}
                                suffix="%"
                                prefix={<AreaChartOutlined style={{ color: stats.avgProgress >= 50 ? '#52c41a' : '#faad14', marginRight: 6 }} />}
                                valueStyle={{ color: stats.avgProgress >= 50 ? '#52c41a' : '#faad14', fontWeight: 700, fontSize: 26 }}
                            />
                        </Card>
                    </Col>
                </Row>
                )}

                {/* Taula principal amb estil Premium */}
                <Card
                    bordered={false}
                    bodyStyle={{ padding: 0 }}
                    style={{
                        borderRadius: 14,
                        overflow: 'hidden',
                        boxShadow: '0 4px 16px rgba(0,0,0,0.05)',
                        background: '#fff',
                    }}
                >
                    {isAdmin ? (
                        <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={onDragEnd}>
                            <SortableContext items={dades.map((i) => i.id)} strategy={verticalListSortingStrategy}>
                                {tableContent}
                            </SortableContext>
                        </DndContext>
                    ) : (
                        tableContent
                    )}
                </Card>
            </Content>

            {!loading && !isGameModal && (
                <FloatButton.Group
                    trigger="click"
                    type="primary"
                    style={{ insetInlineStart: 97 }}
                    icon={<IoOptions />}
                >
                    {(user.tipus === "0" || user.tipus === "1") && (
                        <>
                            <FloatButton
                                shape="circle"
                                onClick={() => setModalImportExcel(true)}
                                style={{ backgroundColor: '#237804' }}
                                icon={<FileExcelOutlined style={{ color: 'black' }} />}
                                tooltip="Importar Excel"
                            />
                            <FloatButton
                                shape="circle"
                                onClick={() => {
                                    setSelected({ id: 0, estat: 1 });
                                    setModal(true);
                                }}
                                style={{ backgroundColor: AvaluacioColors.colors.color6 }}
                                icon={<BiPlus />}
                            />
                        </>
                    )}
                    <FloatButton
                        shape="circle"
                        type="default"
                        onClick={() => checkDades(true)}
                        style={{ backgroundColor: JutgeColors.colors.color6 }}
                        icon={<BiRefresh />}
                    />

                </FloatButton.Group>
            )}

            {modalImportExcel && (
                <ImportarActivitatCompletaExcelModal
                    visible={modalImportExcel}
                    userId={userId + ""}
                    onClose={() => setModalImportExcel(false)}
                    onSuccess={() => checkDades(true)}
                />
            )}

            {modal && (
                <ConfiguracioModal
                    activitat={selected}
                    visible={modal}
                    onClose={onCloseModal}
                    defaultTipus={0}
                />
            )}
            {modalE && (
                <ExercicisModal
                    nom={selected.nom}
                    id_activitat={selected.id}
                    visible={modalE}
                    onClose={onCloseModal}
                />
            )}
            {modalCopy && (
                <CopyModal id_practica={selected.id} visible={modalCopy}
                    onClose={onCloseModal}
                />
            )}
            {modalAlumnes && (
                <ActivitatAlumnesModal
                    activitat={selected}
                    visible={modalAlumnes}
                    onClose={() => setModalAlumnes(false)}
                />
            )}
            {showJavamonModal && (
                <SelectJavamonTimeModal
                    visible={showJavamonModal}
                    userId={userId}
                    onClose={() => setShowJavamonModal(false)}
                    onSelect={async (idJavamon) => {
                        console.log("Selected Javamon:", idJavamon);
                        setShowJavamonModal(false);
                        const ok = await PostUseTimeJavamon(activityForJavamon, userId, idJavamon);
                        if (ok) {
                            checkDades(true);
                            Modal.success({ content: 'Plazo ampliado correctamente!' });
                        }
                    }}
                />
            )}
            {showJavamonNotaModal && (
                <SelectJavamonNotaModal
                    visible={showJavamonNotaModal}
                    userId={userId}
                    onClose={() => setShowJavamonNotaModal(false)}
                    onSelect={async (idJavamon) => {
                        setShowJavamonNotaModal(false);
                        const ok = await PostUseNotaJavamon(activityForJavamon, userId, idJavamon);
                        if (ok) {
                            checkDades(true);
                            Modal.success({ content: 'Nota subida correctamente! (+0.5 pts)' });
                        } else {
                            Modal.error({ content: 'No se ha podido subir la nota. Verifica que tengas entregas.' });
                        }
                    }}
                />
            )}

            {incenseTimeLeft && (
                <div style={{ position: 'fixed', top: 80, right: 20, zIndex: 1000 }}>
                    <Alert
                        message="Incienso Activo"
                        description={`Tiempo restante: ${incenseTimeLeft}`}
                        type="info"
                        showIcon
                        icon={<MdCatchingPokemon />}
                        style={{ border: '1px solid #1890ff', backgroundColor: '#e6f7ff' }}
                    />
                </div>
            )}

            <Modal
                title={
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <AreaChartOutlined style={{ color: '#722ed1', fontSize: 20 }} />
                        <span>Estadístiques de l'Activitat</span>
                    </div>
                }
                open={modalEstadistiques}
                onCancel={() => {
                    setModalEstadistiques(false);
                    setTimeout(() => setSelectedEstadistiquesId(null), 300);
                }}
                footer={null}
                width="95vw"
                style={{ top: 20 }}
                styles={{ body: { padding: 0, maxHeight: '85vh', overflowY: 'auto' } }}
                destroyOnClose
            >
                {selectedEstadistiquesId && (
                    <ActivitatsIdEstadistiques idActivitatProp={selectedEstadistiquesId} />
                )}
            </Modal>

            {modalAssignarRAs && (
                <AssignarRAsMassiuModal
                    visible={modalAssignarRAs}
                    onClose={(updated: boolean) => {
                        setModalAssignarRAs(false);
                        if (updated) {
                            setSelectedRowKeys([]);
                            checkDades(false);
                        }
                    }}
                    selectedItems={(dades || []).filter((d: any) => selectedRowKeys.includes(d.id))}
                    userId={userId}
                />
            )}
        </>
    );
};

export default Activitats;
